module.exports = __webpack_public_path__ + "img/coins-balance-bg.5441b0cb.png";